<script setup lang="ts">
/**
 * Shooting stars — quiet twinkling starfield with occasional comet streaks.
 * Deterministic placement keeps SSR and client markup identical.
 */
const rand = (() => {
  let seed = 7
  return () => {
    seed = (seed * 48271) % 2147483647
    return seed / 2147483647
  }
})()

const stars = Array.from({ length: 34 }, () => ({
  left: `${Math.round(rand() * 100)}%`,
  top: `${Math.round(rand() * 100)}%`,
  size: `${(1 + rand() * 2).toFixed(1)}px`,
  twinkle: `${(4 + rand() * 6).toFixed(1)}s`
}))

const comets = [
  { left: '12%', top: '18%', dur: '11s', delay: '0s', angle: '-32deg', x: '420px', y: '260px' },
  { left: '55%', top: '8%', dur: '13s', delay: '-5s', angle: '-40deg', x: '380px', y: '310px' },
  { left: '30%', top: '40%', dur: '15s', delay: '-9s', angle: '-28deg', x: '460px', y: '240px' }
]
</script>

<template>
  <div
    class="site-hero-anim"
    aria-hidden="true"
  >
    <span
      v-for="(s, i) in stars"
      :key="`s${i}`"
      class="site-anim-star-still opacity-40"
      :style="{ 'left': s.left, 'top': s.top, 'width': s.size, 'height': s.size, '--twinkle': s.twinkle }"
    />
    <span
      v-for="(c, i) in comets"
      :key="`c${i}`"
      class="site-anim-star"
      :style="{
        'left': c.left,
        'top': c.top,
        '--dur': c.dur,
        '--delay': c.delay,
        '--angle': c.angle,
        '--travel-x': c.x,
        '--travel-y': c.y,
        'animation-delay': c.delay
      }"
    />
  </div>
</template>
